import { fg } from '@atlassian/jira-feature-gating';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { jsmWorkItemBrowseRoute } from '@jira/router-routes__jsm-work-item-service-request-routes/src/jsmWorkItemBrowseRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { jsmWorkItemServiceRequestEntryPoint } from '@jira/spa-apps__jsm-work-item-service-request/src/jsmWorkItemServiceRequestEntryPoint.entrypoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

const jsmWorkItemBrowsePageEntrypoint = createPageEntryPoint({
	main: jsmWorkItemServiceRequestEntryPoint,
});

export const jsmWorkItemBrowseRouteEntry: Route = createEntry(jsmWorkItemBrowseRoute, () => ({
	group: 'servicedesk',

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [...getNavigationResources()],

	entryPoint: () =>
		fg('jsm_aniv_routing_phase_1') ? jsmWorkItemBrowsePageEntrypoint : notFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
